<template>
	<div class="flex w-full">
		<div
			class="pb-30 flex-1 create-content body-content"
			:class="{ 'body-content--active': isSlideOpen }"
		>
			<div class="__goal-management-student-detail p-10 md-down:px-4">
				<div class="flex items-center justify-between">
					<div
						class="
							__breadcrumbs
							text-sm text-neutral-500
							font-semibold
							flex-nowrap flex
							items-center
						"
					>
						{{ title }}
					</div>
					<button
						type="button"
						class="
							button-p
							text-center
							w-fit
							btn--text
							text-neutral-500
							hover:text-neutral-600
						"
						@click="back"
					>
						<svg
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							class="mr-2 text-neutral-400"
						>
							<path
								d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
								fill="currentColor"
							/>
							<path
								d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
								fill="currentColor"
							/>
						</svg>
						Thoát
					</button>
				</div>
				<div class="__goal-management-student-detail__header pt-5">
					<div
						class="
							flex
							justify-between
							items-center
							w-full
							flex-wrap
							gap-8
						"
					>
						<div class="flex gap-6" v-if="groupClass">
							<UserGroup
								:data="groupClass?.students"
								placement="bottom-start"
								class="mt-2"
							/>
							<div>
								<div
									class="text-neutral-700 font-bold text-4xl"
								>
									{{ groupClass?.name }}
								</div>
								<div
									class="
										uppercase
										text-green-500
										font-semibold
									"
								>
									{{ groupClass?.students?.length }} học sinh
								</div>
							</div>
						</div>
						<div
							class="
								flex
								md-down:w-full
								justify-start
								flex-wrap
								gap-4
							"
						>
							<div>
								<button
									type="button"
									class="button-p text-center btn--ghost"
									@click="openKHDK"
								>
									{{ button }}
								</button>
							</div>
							<div>
								<button
									type="button"
									class="button-p text-center btn--ghost"
									@click="openMTHT"
								>
									Xem MT hoàn thành
								</button>
							</div>
						</div>
					</div>
					<div
						class="
							mt-10
							w-full
							md:overflow-x-auto md:scroll-bar--none
						"
					>
						<div class="border-b border-neutral-200 md-down:hidden">
							<nav
								class="-mb-px flex space-x-8 tabs"
								aria-label="Tabs"
							>
								<router-link
									v-for="tab in tabs"
									:key="tab.value"
									:to="{
										name: tab.value,
										query: {
											...$route.query,
										},
									}"
									class="
										border-transparent
										text-neutral-500
										hover:text-yellow-700
										hover:border-yellow-500
										whitespace-nowrap
										py-3
										px-1
										border-b-2
										font-semibold
									"
								>
									{{ tab?.label }}
								</router-link>
							</nav>
						</div>
						<div class="md:hidden">
							<div class="p-6 bg-white select-tabs">
								<Multiselect
									v-model="tab"
									deselect-label="Đã chọn"
									track-by="value"
									:options="tabs"
									:searchable="true"
									label="label"
									:allow-empty="false"
									selectLabel=""
									placeholder=""
								>
									<template #noResult>
										Không tìm thấy kết quả
									</template>
									<template v-slot:option="props">
										<div
											class="
												flex flex-nowrap
												items-center
											"
										>
											<div>
												{{ props.option.label }}
											</div>
										</div>
									</template>
									<template v-slot:singleLabel="{ option }">
										<div
											class="
												flex flex-nowrap
												items-center
												font-medium
											"
										>
											<div>{{ option.label }}</div>
										</div>
									</template>
								</Multiselect>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="
					__goal-management-student-detail__overview
					px-10
					md-down:px-4
				"
			>
				<router-view
					@updated="onUpdated"
					v-model:re-fetch="refreshTime"
				/>
			</div>
		</div>
		<div
			class="h-screen create-content slide-content"
			:class="{ 'slide-content--active': isSlideOpen }"
		>
			<div
				class="h-screen fixed top-0 right-0 overflow-y-auto"
				style="width: inherit; background: #faf5f1"
			>
				<DataSlideOverBank
					@close="isSlideOpen = false"
					@updated="isUpdated = false"
					v-model:is-completed="isCompleted"
					v-model:is-updated="isUpdated"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { $api } from '@/services';
import UserGroup from '@/components/elements/UserGroup.vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import { _ROUTER_NAME } from '@/enums';
import DataSlideOverBank from '@/views/groupClassPlanCreateGoalFuture/features/DataSlideOverBank.vue';

export default {
	name: 'CreateGoal',
	components: { DataSlideOverBank, Multiselect, UserGroup },

	data() {
		return {
			isSlideOpen: true,
			isCompleted: true,
			isUpdated: false,
			groupClass: null,
			refreshTime: new Date().getTime(),
			tab: {
				label: 'Kế hoạch hiện tại',
				value: _ROUTER_NAME.GROUP_CLASS_PLANS_DETAIL_REPORT,
			},
		};
	},

	watch: {
		tab: {
			deep: true,
			handler(value) {
				if (value) {
					this.$router.push({
						name: value.value,
						query: { ...this.$route.query },
					});
				}
			},
		},

		$route: {
			immediate: true,
			deep: true,
			handler(value) {
				const name = value?.name;
				this.tab = this.tabs.find((item) => item.value === name);
			},
		},
	},

	computed: {
		id() {
			return this.$route.params?.id;
		},

		org() {
			return this.$store.state.profile.current_org;
		},

		type() {
			return this.$route.query?.type;
		},

		title() {
			switch (this.type) {
				case 'library':
					return 'Chỉnh sửa Ngân hàng mục tiêu';
				default:
					return 'Chỉnh sửa Kế hoạch hiện tại';
			}
		},

		button() {
			switch (this.type) {
				case 'library':
					return 'Xem trước NHMT';
				default:
					return 'Xem trước KHDK';
			}
		},

		tabs() {
			const tabs = [
				{
					label: 'Mục tiêu mới',
					value: _ROUTER_NAME.GROUP_CLASS_PLANS_DETAIL_CREATE_BY_NEW_GOAL,
				},
			];

			if (!this.type || this.type !== 'library') {
				tabs.push({
					label: 'Mục tiêu tạm dừng',
					value: _ROUTER_NAME.GROUP_CLASS_PLANS_DETAIL_CREATE_BY_NEW_GOAL_FROM_STOPPED,
				});
				tabs.push({
					label: 'Mục tiêu hoàn thành',
					value: _ROUTER_NAME.GROUP_CLASS_PLANS_DETAIL_CREATE_BY_NEW_GOAL_FROM_COMPLETED,
				});
				tabs.push({
					label: 'Ngân hàng mục tiêu',
					value: _ROUTER_NAME.GROUP_CLASS_PLANS_DETAIL_CREATE_BY_NEW_GOAL_FROM_LIB,
				});
			} else {
				tabs.push({
					label: 'Thư viện nội bộ',
					value: _ROUTER_NAME.GROUP_CLASS_PLANS_DETAIL_CREATE_BY_NEW_GOAL_FROM_TVMT,
				});
			}

			return tabs;
		},
	},

	created() {
		this.fetchGroupClassDetail();
	},

	methods: {
		back() {
			this.$router.push(`/group-class-plans/${this.id}`);
		},

		async fetchGroupClassDetail() {
			try {
				const {
					data: { data },
				} = await $api.groupClasses.detail(this.id);
				this.groupClass = data;
			} catch (e) {
				console.log(e);
			}
		},

		openKHDK() {
			this.isSlideOpen = true;
			this.isCompleted = true;
			this.isUpdated = false;
		},

		openMTHT() {
			this.isSlideOpen = true;
			this.isCompleted = false;
			this.isUpdated = false;
		},

		onUpdated() {
			this.isUpdated = true;
		},
	},
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/_responsive';

.tabs {
	.router-link-exact-active {
		@apply text-yellow-700 border-yellow-500;
	}
}

.create-content {
	transition: all 0.5s ease;
}

.body-content {
	transition: all 0.5s ease;
	min-width: 100vw;

	@include media-breakpoint-up(md) {
		min-width: auto;
	}

	&--active {
		@include media-breakpoint-up(md) {
			width: 50vw;
		}
	}
}

.slide-content {
	width: 0;

	&--active {
		width: 50vw;
	}

	@include media-breakpoint-down(md) {
		&--active {
			position: fixed;
			width: 100vw !important;
		}
	}
}
</style>
